// RTK Query slice for subscription management
import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./baseQuery";

export const subscriptionApi = createApi({
  reducerPath: "subscriptionApi",
  baseQuery: dynamicBaseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  keepUnusedDataFor: 300,
  tagTypes: ["Subscription", "SubscriptionTiers", "PaymentHistory"],
  endpoints: (builder) => ({
    // Get current subscription for the authenticated user
    getCurrentSubscription: builder.query({
      query: () => ({
        url: "api/subscription-tiers/current",
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      }),
      providesTags: ["Subscription"],
    }),

    // Get all available subscription tiers
    getSubscriptionTiers: builder.query({
      query: () => ({
        url: "api/subscription-tiers",
        method: "GET",
      }),
      providesTags: ["SubscriptionTiers"],
    }),

    // Get payment history
    getPaymentHistory: builder.query({
      query: (startingAfter) => ({
        url: startingAfter
          ? `api/payment-history?starting_after=${startingAfter}`
          : "api/payment-history",
        method: "GET",
      }),
      providesTags: ["PaymentHistory"],
    }),

    // Preview subscription change
    previewSubscriptionChange: builder.mutation({
      query: ({ targetTierId, billingCycle }) => ({
        url: "api/subscription-changes/preview",
        method: "POST",
        body: { targetTierId, billingCycle },
      }),
    }),

    // Submit subscription change (upgrade/downgrade)
    changeSubscription: builder.mutation({
      query: ({ targetTierId, billingCycle, acceptedTerms, companyInfo }) => ({
        url: "api/subscription-changes",
        method: "POST",
        body: { targetTierId, billingCycle, acceptedTerms, companyInfo },
      }),
      invalidatesTags: ["Subscription", "PaymentHistory"],
    }),

    // Cancel pending subscription change
    cancelPendingChange: builder.mutation({
      query: () => ({
        url: "api/subscription-changes/cancel-pending",
        method: "POST",
      }),
      invalidatesTags: ["Subscription"],
    }),
  }),
});

export const {
  useGetCurrentSubscriptionQuery,
  useGetSubscriptionTiersQuery,
  useGetPaymentHistoryQuery,
  useLazyGetPaymentHistoryQuery,
  usePreviewSubscriptionChangeMutation,
  useChangeSubscriptionMutation,
  useCancelPendingChangeMutation,
} = subscriptionApi;
